<div *ngIf="!asEmbedComponent" class="app-grid-fluid garage">
  <div class="grid grid-nogutter justify-content-center margin-over-bottom-sidebar">
    <div class="col-12 sm:col-10 xl:col-5" [style]="{maxWidth: '900px'}">
      <app-timeline [writingPostEnabled]="false" [postTypes]="postTypes" [posts]="timelinePosts" [singlePostMode]="true"
        [noResultsMsg]="'common.no_posts'|translate" [alreadyOnRecentMsg]="'common.already_on_recent'"
        [fetchDeleted]="fetchDeleted"></app-timeline>
    </div>
  </div>
</div>

<ng-container *ngIf="asEmbedComponent">
  <app-timeline [writingPostEnabled]="false" [postTypes]="postTypes" [posts]="timelinePosts" [singlePostMode]="true"
    [noResultsMsg]="'common.no_posts'|translate" [alreadyOnRecentMsg]="'common.already_on_recent'"
    [fetchDeleted]="fetchDeleted"></app-timeline>
</ng-container>
